import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import {
  Refresh as RefreshIcon,
} from '@mui/icons-material';

interface ErrorStateProps {
  error: string | Error;
  onRetry?: () => void;
  fullHeight?: boolean;
  minHeight?: number | string;
  showDetails?: boolean;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  error,
  onRetry,
  fullHeight = false,
  minHeight = 200,
  showDetails = false,
}) => {
  const errorMessage = typeof error === 'string' ? error : error.message;
  const errorDetails = typeof error === 'object' && 'stack' in error ? error.stack : undefined;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        height: fullHeight ? '100%' : 'auto',
        minHeight: fullHeight ? 'auto' : minHeight,
      }}
    >
      <Alert 
        severity="error" 
        sx={{ 
          mb: 2,
          width: '100%',
          maxWidth: 600,
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {errorMessage}
        </Typography>
        {showDetails && errorDetails && (
          <Typography 
            variant="caption" 
            component="pre" 
            sx={{ 
              mt: 1,
              whiteSpace: 'pre-wrap',
              fontFamily: 'monospace',
              fontSize: '0.75rem',
            }}
          >
            {errorDetails}
          </Typography>
        )}
      </Alert>
      {onRetry && (
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};
